// Deprecated: This service is a temporary solution for tracking analytics events
// It will be replaced by a frontend tracking solution in the future
import { enqueue, flush, flushOnUnload, startAnalyticsQueue } from './analytics/queue';

export type AnalyticsEvent =
  | 'rules_of_road_accepted'
  | 'session_resumed'
  | 'session_dismissed'
  | 'clear_all_completed_tasks'
  | 'task_created'
  | 'tracked_action_created'
  | 'recommended_task_added'
  | 'recommended_task_dismissed'
  | 'recommended_tasks_cleared'
  | 'tracked_action_updated'
  | 'task_updated'
  | 'task_reopened'
  | 'subtask_added'
  | 'subtask_deleted'
  | 'subtask_uncompleted'
  | 'subtask_completed'
  | 'tracked_actions_viewed'
  | 'tracked_actions_filtered'
  | 'recommended_tasks_refreshed'
  | 'manage_channels_opened'
  | 'channel_preferences_saved'
  | 'channel_preferences_save_failed'
  | 'task_section_expanded'
  | 'task_section_collapsed'
  | 'task_dragged'
  | 'task_dropped'
  | 'task_reordered'
  | 'filter_applied'
  | 'filter_cleared'
  | 'quick_action_opened'
  | 'quick_action_used'
  | 'task_limit_reached'
  | 'task_limit_dialog_shown'
  | 'focus_time_scheduled'
  | 'add_task_clicked'
  | 'new_badge_displayed'
  | 'new_badge_dismissed'
  | 'accessbility_feature_used'
  | 'keyboard_navigation_used'
  | 'task_manually_created_per_day'
  | 'task_recommended_per_day'
  | 'task_tracked_others_per_day'
  | 'task_moved_cross_section'
  | 'chat_feedback_submitted'
  | 'chat_suggestion_selected'
  | 'chat_input_submitted'
  | 'surface_viewed'
  | 'surface_time_spent'
  | 'task_completed'
  | 'handover_journey_completed'
  | 'meeting_booking_completed'
  | 'page_loaded'
  | 'overview_insight_feedback_submitted';

/**
 * Analytics service for tracking user events
 * Note: This is a temporary solution that will be replaced by a frontend tracking solution
 */
export const analyticsService = {
  /**
   * Queue an analytics event. Events are batched and flushed by the queue, and
   * flushed best-effort on page teardown.
   */
  trackEvent: async (event: AnalyticsEvent, metadata?: Record<string, unknown>): Promise<void> => {
    try {
      startAnalyticsQueue();
      enqueue({ event, occurred_at: new Date().toISOString(), properties: metadata });
    } catch (error) {
      // Silently fail - don't interrupt user experience for analytics failures
      console.warn('Failed to track analytics event:', event, error);
    }
  },

  /** Forces an immediate flush of any queued events. */
  flush: (): Promise<void> => flush(),

  /** Synchronous best-effort flush for page teardown. */
  flushOnUnload: (): void => flushOnUnload(),
};
